var render = function (_h,_vm) {var _c=_vm._c;return _c('img',{class:[
        'insights-loading',
        _vm.props.centered ? 'centered' : '',
        _vm.data.class,
        _vm.data.staticClass
      ],style:([
         _vm.data.style,
         _vm.data.staticStyle
     ]),attrs:{"src":require('@/assets/images/ajax-loader.gif'),"width":"160","height":"20","alt":"Loading..."}})}
var staticRenderFns = []

export { render, staticRenderFns }